class Branch {
    constructor(id) {
        this.id = id;
        this.organizationID = new URLSearchParams(window.location.search).get('organizationID');
    }
    remove(branchName = undefined, branchCustomZoneForwarding = undefined){
        let html = `<span class="text-center text-primary">Branch/Cloud `+(branchName !== undefined ? `<b>`+branchName+`</b> ` : ``)+`is going to be removed!</span>`;
        if(branchCustomZoneForwarding !== undefined && branchCustomZoneForwarding){
            html = `
                    <div class="text-center text-primary">Branch/Cloud `+(branchName !== undefined ? `<b>`+branchName+`</b> ` : ``)+`is going to be removed!</div>
                    <div class="text-center text-primary mt-5">You have the following <b>Custom Zone Forwarding configured</b> within Branch/Cloud: `+branchCustomZoneForwarding+`. By removing this Cloud/Branch, these Custom Zone Forwarding will not work.</div>
                    <div class="form-check mt-5">
                        <input class="form-check-input float-none corsor-pointer" name="agreeSwalCheckbox" type="checkbox" value="" id="agreeSwalCheckbox" />
                        <label class="form-check-label text-primary corsor-pointer" for="agreeSwalCheckbox">
                            I agree
                        </label>
                    </div>`
        }
        const thisClass = this;
        Swal.fire({
            html: html,
            icon: "warning",
            iconColor: "#FF5206",
            buttonsStyling: false,
            reverseButtons: true,
            showCancelButton: true,
            confirmButtonText: "Yes, remove it!",
            customClass: {
                confirmButton: "btn btn-danger mt-0",
                cancelButton: 'btn btn-light-primary mt-0',
            },
            showLoaderOnConfirm: true,
            returnFocus: false,
            preConfirm: () => {
                let deleteGatewaySwalCheckbox = document.querySelector('input[name="agreeSwalCheckbox"]');
                if(deleteGatewaySwalCheckbox && !deleteGatewaySwalCheckbox.checked){
                    Swal.showValidationMessage(`You need to agree`);
                    return;
                }

                return fetch('/branches?do=removeBranch&organizationID='+thisClass.organizationID+'&branchID='+thisClass.id)
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(response.statusText)
                        }
                        return response.json();
                    }).catch(error => {
                        Swal.showValidationMessage(`Request failed: ${error}`)
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
            allowEscapeKey: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                if(result.value.status === 'success'){
                    toastr.success(result.value.message);
                }else if(result.value.status === 'error'){
                    toastr.error(result.value.message);
                }
                let editBranchModal = document.getElementById('edit_branch_modal');
                if(bootstrap.Modal.getInstance(editBranchModal) !== null){
                    bootstrap.Modal.getInstance(editBranchModal).hide();
                }
                new PageDatatableReload();

                let branchCountContainer = document.getElementById('branchCountContainer');
                if(branchCountContainer){
                    branchCountContainer.textContent = parseInt(branchCountContainer.textContent) - 1;
                }
            }
        });
    }
}
window.Branch = Branch;